import React, { useEffect, useState } from "react";
import { ConfigProvider, Select, Space } from "antd";
import theme from "@theme/";
import SC from "./style";
import { countryCodes } from "./countryData.js";

const CountryCodeDropdown = (props) => {
  const { onChange = () => {}, defaultValue, name } = props;
  const [selectedValue, setSelectedValue] = useState();

  useEffect(() => {
    setSelectedValue(defaultValue);
  }, [defaultValue]);

  const options = countryCodes.map(({ code, label }) => ({
    label: String(code),
    value: label,
    code, // Keep the code for reference
  }));

  const handleDropdownChange = (value) => {
    const selectedOption = options.find((option) => option.value === value);
    setSelectedValue(selectedOption?.label);
    onChange(name, selectedOption?.label);
  };

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#ED850C",
          colorBorder: theme.colors.bordertask,
          colorText: "black",
          colorTextPlaceholder: "rgba(0, 0, 0, 0.5)",
        },
      }}
    >
      {SC.Globalstyles}
      <Select
        showSearch
        // allowClear
        placeholder="Select one country"
        value={`${selectedValue}`}
        onChange={handleDropdownChange}
        options={options}
        style={{
          width: "120px",
          height: "29px",
          textAlign: "left",
          cursor: "pointer",
        }}
        filterOption={(input, option) =>
          option.value.toLowerCase().includes(input.toLowerCase()) ||
          option.label.toLowerCase().includes(input.toLowerCase())
        }
        optionRender={(option) => (
          <Space>
            <span
              title={option.value}
              style={{
                maxWidth: "100px",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                display: "inline-block",
                verticalAlign: "middle",
              }}
            >
              ({option.label}) {option.value}
            </span>
          </Space>
        )}
      />
    </ConfigProvider>
  );
};

export default CountryCodeDropdown;
